module.exports = __webpack_public_path__ + "img/guide_3.80c8dd51.png";